var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98827 11.0144L13.6857 6.47621C13.7636 6.40167 13.8255 6.31299 13.8677 6.21529C13.9099 6.11758 13.9316 6.01278 13.9316 5.90693C13.9316 5.80108 13.9099 5.69628 13.8677 5.59858C13.8255 5.50087 13.7636 5.41219 13.6857 5.33765C13.5299 5.18831 13.3192 5.10449 13.0996 5.10449C12.8799 5.10449 12.6692 5.18831 12.5134 5.33765L8.3564 9.30658L4.24095 5.33765C4.08518 5.18831 3.87445 5.10449 3.65481 5.10449C3.43516 5.10449 3.22444 5.18831 3.06867 5.33765C2.99011 5.41191 2.92761 5.50046 2.8848 5.59818C2.84198 5.6959 2.8197 5.80085 2.81925 5.90693C2.8197 6.01302 2.84198 6.11796 2.8848 6.21568C2.92761 6.3134 2.99011 6.40195 3.06867 6.47621L7.76611 11.0144C7.84396 11.0958 7.93845 11.1608 8.04362 11.2052C8.1488 11.2496 8.26237 11.2725 8.37719 11.2725C8.49201 11.2725 8.60558 11.2496 8.71075 11.2052C8.81593 11.1608 8.91042 11.0958 8.98827 11.0144Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsArrow);
export default __webpack_public_path__ + "static/media/stats__arrow.4743bcebca33af1ecdbac18a3defe237.svg";
export { ForwardRef as ReactComponent };